import { ImagesPreviewWrapper } from './image-preview-wrapper';
import { PdfViewWrapper } from './pdf-preview-wrapper';
import { FC } from 'react';

type Props = {
  urls: string[];
  onClose: () => void;
};

export const FilePreviewWrapper: FC<Props> = ({ urls, onClose }) => {
  if (urls.length == 1 && urls[0].endsWith('.pdf')) return <PdfViewWrapper onClose={onClose} url={urls[0]} />;

  return <ImagesPreviewWrapper onClose={onClose} urls={urls.filter((x) => !x.endsWith('.pdf'))} />;
};
